import styled from 'styled-components';
import { Header as HeaderComponent } from '@/components/Header/Header';

export const Header = styled(HeaderComponent)`
  border-bottom: none;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 0 30px;
  background: ${({ theme }) => theme.palette.primary.background};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1280px;

  & > * {
    width: 100%;
  }
`;
